import { resetQrApi } from "core/http/service/auth";
import type { LoginParams } from "core/http/service/auth/paramsTypes";
import { all, call, put, takeLatest } from "redux-saga/effects";
import type { PayloadAction } from "@reduxjs/toolkit";
import { resetQrFailed, resetQrStart, resetQrSuccess } from "../redux/resetQr";
import { toast } from "react-toastify";
import { base64ToBlob } from "helper/file";

function* resetQrWork(action: PayloadAction<LoginParams>) {
  const params = action.payload;

  try {
    const response = yield call(resetQrApi, params);
    if (response) {
      const blobData = !!response?.qrCode
        ? base64ToBlob(response?.qrCode, "image/jpeg")
        : null;

      yield put({
        type: resetQrSuccess.type,
        payload: blobData,
      });
    }
  } catch (error) {
    yield put({
      type: resetQrFailed.type,
    });

    toast.error(
      error.status === 403
        ? "Không có quyền truy cập vào hệ thống, vui lòng liên hệ quản trị viên"
        : "Sai tên đăng nhập hoặc mật khẩu. Vui lòng thử lại"
    );
  }
}

function* watchResetQr() {
  yield takeLatest(resetQrStart.type, resetQrWork);
}

export default function* resetQrSaga() {
  yield all([watchResetQr()]);
}
